/* eslint-disable */
import React, { useState, useContext, useEffect, useMemo } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { AuthContext } from "../../contexts/AuthContext";
import { Dropdown, DropdownButton, Form, Button, Modal, Col, Table } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import es from "date-fns/locale/es";
import ReactLoading from "react-loading";
import "react-datepicker/dist/react-datepicker.css";
import "../../index.css";
import "./Apointment.css";

registerLocale("es", es);

function Apointment() {
  const { user1, isAuth } = useContext(AuthContext);

  // ==========================================
  // ESTADOS
  // ==========================================
  const [show, setShow] = useState(false);
  const [modo, setModo] = useState("obraSocial"); // "obraSocial" | "particular"
  const [formulario, setFormulario] = useState(true);

  // Datos del endpoint
  const [citasObraSocial, setCitasObraSocial] = useState([]);
  const [citasParticular, setCitasParticular] = useState([]);
  const [cargandoObra, setCargandoObra] = useState(false);
  const [cargandoParticular, setCargandoParticular] = useState(false);
  const [particularCargado, setParticularCargado] = useState(false);

  // Selección
  const [doctor, setDoctor] = useState("");
  const [doctorNombre, setDoctorNombre] = useState("Elige");
  const [doctorApellido, setDoctorApellido] = useState("Doctor");
  const [selectedDate, setSelectedDate] = useState(null);
  const [hora, setHora] = useState("Hora");
  const [note, setNote] = useState("Escribe aqui algun comentario a tu turno");
  const [seleccionDesdeTabla, setSeleccionDesdeTabla] = useState(false);

  const API = process.env.REACT_APP_API;
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  // ==========================================
  // HANDLERS DEL MODAL
  // ==========================================
  const handleShow = () => setShow(true);
  const handleClose = () => { setShow(false); resetSeleccion(); setModo("obraSocial"); };

  // ==========================================
  // LISTA ACTIVA SEGÚN MODO
  // ==========================================
  const citasDisponibles = modo === "obraSocial" ? citasObraSocial : citasParticular;
  const cargando = modo === "obraSocial" ? cargandoObra : cargandoParticular;

  // ==========================================
  // FETCH — LLAMADA 1 AL ABRIR EL MODAL
  // ==========================================
  useEffect(() => {
    if (!show) return;

    // Formulario del paciente
    axios.get(`${API}user/${user1.id}`, { headers })
      .then(({ data }) => setFormulario(data.formulario))
      .catch(console.error);

    // Citas con la obra social del paciente
    setCargandoObra(true);

    axios.post(`${API}proximasCitas`, { id: user1.id, obraSocial: user1.obraSocial }, { headers })
      .then(({ data }) => setCitasObraSocial(data))
      .catch(console.error)
      .finally(() => setCargandoObra(false));

    // eslint-disable-next-line
  }, [show]);

  // ==========================================
  // FETCH — LLAMADA 2 AL PRESIONAR "PARTICULAR"
  // ==========================================
  const handleModoParticular = () => {
    setModo("particular");
    resetSeleccion();

    if (particularCargado || user1.obraSocial === "Particular") return;

    setCargandoParticular(true);
    axios.post(`${API}proximasCitas`, { id: user1.id, obraSocial: "Particular" }, { headers })
      .then(({ data }) => { setCitasParticular(data); setParticularCargado(true); })
      .catch(console.error)
      .finally(() => setCargandoParticular(false));
  };

  const handleModoObraSocial = () => { setModo("obraSocial"); resetSeleccion(); };

  // ==========================================
  // RESET DE SELECCIÓN
  // ==========================================
  const resetSeleccion = () => { setDoctor(""); setDoctorNombre("Elige"); setDoctorApellido("Doctor"); setSelectedDate(null); setHora("Hora"); setSeleccionDesdeTabla(false); };

  // ==========================================
  // LISTAS DERIVADAS
  // ==========================================

  // Doctores únicos
  const doctoresDisponibles = useMemo(() => {
    const map = new Map();
    citasDisponibles.forEach(c => {
      if (!map.has(c.profesional._id)) { map.set(c.profesional._id, c.profesional); }
    });
    return [...map.values()].sort((a, b) => `${a.apellido} ${a.nombre}`.localeCompare(`${b.apellido} ${b.nombre}`));
  }, [citasDisponibles]);

  // fechaStr para comparar contra el endpoint
  const fechaStr = selectedDate ? dayjs(selectedDate).format("YYYY-MM-DD") : "";

  // Horas disponibles para doctor + fecha
  const horasDisponibles = useMemo(() => {
    if (!doctor || !fechaStr) return [];
    return citasDisponibles.filter(c => c.profesional._id === doctor && c.fecha === fechaStr).map(c => c.hora).sort();
  }, [citasDisponibles, doctor, fechaStr]);

 // ✅ Nuevo: filtra desde la primera cita disponible
const citasTabla = useMemo(() => {
  if (citasDisponibles.length === 0) return [];

  // Ordenar todas las citas por fecha+hora
  const ordenadas = [...citasDisponibles].sort((a, b) => {
    const fa = dayjs(`${a.fecha}T${a.hora}:00`);
    const fb = dayjs(`${b.fecha}T${b.hora}:00`);
    return fa - fb;
  });

  // La primera cita disponible = punto de partida
  const primerDia = dayjs(ordenadas[0].fecha).startOf("day");
  const limite = primerDia.add(14, "day");

  return ordenadas.filter(c => {
    const f = dayjs(c.fecha);
    return f.isSame(primerDia) || (f.isAfter(primerDia) && f.isBefore(limite));
  });
}, [citasDisponibles]);

  // ==========================================
  // DATOS PARA EL DATEPICKER
  // ==========================================

  // Conteo de slots por fecha (según doctor, o todos si no hay doctor)
  const conteoPorFecha = useMemo(() => {
    const citasFiltradas = doctor ? citasDisponibles.filter(c => c.profesional._id === doctor) : citasDisponibles;

    const mapa = new Map();
    citasFiltradas.forEach(c => { mapa.set(c.fecha, (mapa.get(c.fecha) || 0) + 1); });
    return mapa;
  }, [citasDisponibles, doctor]);

  // Fechas habilitadas (sólo las que tienen al menos 1 slot)
  const fechasHabilitadas = useMemo(() => [...conteoPorFecha.keys()].map(f => dayjs(f).toDate()), [conteoPorFecha]);

  // Colores por densidad: rojo (pocos), amarillo (varios), verde (muchos)
  const highlightDates = useMemo(() => {
    const pocos = [];    // 1-3 → rojo
    const varios = [];   // 4-7 → amarillo
    const muchos = [];   // 8+  → verde

    conteoPorFecha.forEach((cantidad, fechaStrKey) => {
      const fecha = dayjs(fechaStrKey).toDate();
      if (cantidad >= 8) muchos.push(fecha);
      else if (cantidad >= 4) varios.push(fecha);
      else pocos.push(fecha);
    });

    return [
      { "highlight-pocos": pocos },
      { "highlight-varios": varios },
      { "highlight-muchos": muchos },
    ];
  }, [conteoPorFecha]);

  // ==========================================
  // SELECCIONES
  // ==========================================
  const seleccionarDoctor = (doc) => { setDoctor(doc._id); setDoctorNombre(doc.nombre); setDoctorApellido(doc.apellido); setSelectedDate(null); setHora("Hora"); };

  const seleccionarHora = (h) => { setHora(h); };

  const seleccionarDeTabla = (cita) => { setDoctor(cita.profesional._id); setDoctorNombre(cita.profesional.nombre); setDoctorApellido(cita.profesional.apellido); setSelectedDate(dayjs(cita.fecha).toDate()); setHora(cita.hora); setSeleccionDesdeTabla(true); };

  // ==========================================
  // VALIDACIÓN
  // ==========================================
  const seleccionCompleta = doctor && selectedDate && hora && hora !== "Hora";

  // ==========================================
  // GUARDAR
  // ==========================================
  const saveDate = () => {
    if (!seleccionCompleta) {
      return Swal.fire({ icon: "info", title: "Informacion incompleta", text: "Elige todos los campos", confirmButtonText: "Ok", });
    }

    const fechaParaPayload = dayjs(selectedDate).format("YYYY-MM-DD");
    const fechaFormateada = dayjs(selectedDate).format("DD/MM/YYYY");

    const esParticular = modo === "particular";

    Swal.fire({ title: `Tu turno con el/la <br/> Dr. ${doctorNombre} ${doctorApellido}`, html: `<p>Para el <b>${fechaFormateada}</b> a las <b>${hora} hs</b></p>${esParticular ? `<div style="margin-top: 12px;padding: 10px; background-color: #fff3cd;border-left: 4px solid #ffc107;border-radius: 4px;text-align: left;font-size: 14px;"><b>⚠️ Turno particular</b><br/>Este turno <b>no será cubierto por tu obra social</b>.El costo deberá abonarse de forma particular.</div>` : ""}`, icon: "question", showCancelButton: true, reverseButtons: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Agendar", cancelButtonText: "Cancelar", })
      .then((result) => {
        if (!result.isConfirmed) return;

        const jsonSend = {
          date: `${fechaParaPayload}T${hora}:00`,
          profesional: doctor,
          note,
          time: hora,
          type: true,
          user: user1.id,
          primeraVez: !user1.pacienteExistente,
          modalidad: modo,
        };

        axios.post(`${API}schedule/${user1.id}`, jsonSend, { headers })
          .then(() => {
            return axios.patch(`${API}editusers/${user1.id}/${user1.id}`, { pacienteExistente: true }, { headers });
          })
          .then(() => {
            Swal.fire({ icon: "success", title: "Listo! tu turno esta agendado", confirmButtonText: "Ok", timer: 1200, timerProgressBar: true, })
              .then(() => window.location.reload());
          })
          .catch((error) => {
            const message = error.response?.data?.message || "Error desconocido";
            Swal.fire({ icon: "error", title: "Oops...", text: "Lo sentimos esta acción no se pudo completar: " + message, })
              .then(() => window.location.reload());
          });
      });
  };

  // ==========================================
  // RENDER
  // ==========================================
  if (!isAuth || user1.role !== "user") return null;

  const mostrarToggleParticular = user1.obraSocial !== "Particular";

  return (
    <>
      <Button variant="primary" onClick={handleShow}>Agendar turno</Button>

      {!formulario && (
        <Button href="/formulario">Formulario</Button>
      )}

      <Modal show={show} size="xl" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Agendar turno</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Toggle Obra Social / Particular */}
          {mostrarToggleParticular && (
            <div className="d-flex justify-content-center mb-4">
              <div className="btn-group">
                <Button className={modo === "obraSocial" ? "btn-info" : "btn-outline-info"} onClick={handleModoObraSocial}>Mi obra social</Button>
                <Button className={modo === "particular" ? "btn-info" : "btn-outline-info"} onClick={handleModoParticular} disabled={cargandoParticular && !particularCargado}>{cargandoParticular && !particularCargado ? "Cargando..." : `Particular`}</Button>
              </div>
            </div>
          )}

          {cargando ? (
            <div className="d-flex justify-content-center p-5">
              <ReactLoading type="spin" color="rgb(29,191,236)" height="3vw" width="3vw" />
            </div>
          ) : citasDisponibles.length === 0 ? (
            <div className="text-center p-5">
              <h5>No hay turnos disponibles.</h5>
              <p>
                {modo === "obraSocial"
                  ? "Probá con un turno particular o volvé más tarde."
                  : "Volvé a intentar más tarde."}
              </p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-evenly", gap: "20px", }}>
              {/* COLUMNA IZQUIERDA — Dropdowns + DatePicker */}
              <Form style={{ minWidth: "220px", maxWidth: "220px", flex: 1 }}>
                <Col>
                  <Form.Group>
                    <Form.Label>Profesional</Form.Label>
                    <Dropdown>
                      <Dropdown.Toggle variant="outline-info" disabled={seleccionDesdeTabla}>
                        {doctorNombre} {doctorApellido}
                      </Dropdown.Toggle>
                      <Dropdown.Menu style={{ maxHeight: "260px", overflowY: "auto" }}>
                        {doctoresDisponibles.map((doc) => (
                          <Dropdown.Item key={doc._id} onClick={() => seleccionarDoctor(doc)}>
                            <h6 className="alineacion mb-0">
                              {doc.nombre} {doc.apellido}
                            </h6>
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Form.Group>
                </Col>

                <br />

                <Col>
                  <Form.Group>
                    <Form.Label htmlFor="fechaPicker">Fecha</Form.Label>

                    {doctor && (
                      <div className="mb-1" style={{ fontSize: "12px", display: "flex", gap: "10px" }}                      >
                        <span>
                          <span style={{ display: "inline-block", width: "12px", height: "12px", background: "#ffcdd2", borderRadius: "2px", marginRight: "4px", }} />Pocos</span>
                        <span>
                          <span style={{ display: "inline-block", width: "12px", height: "12px", background: "#fff3cd", borderRadius: "2px", marginRight: "4px", }} />Varios</span>
                        <span>
                          <span style={{ display: "inline-block", width: "12px", height: "12px", background: "#c8e6c9", borderRadius: "2px", marginRight: "4px", }} />Muchos</span>
                      </div>
                    )}

                    <div style={{ display: "block", width: "100%" }}>
                      <DatePicker
                        id="fechaPicker"
                        locale="es"
                        selected={selectedDate}
                        onChange={(date) => { setSelectedDate(date); setHora("Hora"); }}
                        includeDates={fechasHabilitadas}
                        highlightDates={highlightDates}
                        dateFormat="dd/MM/yyyy"
                        placeholderText={doctor ? "Elige una fecha" : "Elige un doctor primero"}
                        disabled={!doctor || seleccionDesdeTabla}
                        className="picker"
                        calendarStartDay={1}
                        // todayButton="Hoy"
                        wrapperClassName="d-block w-100"
                      />
                    </div>
                  </Form.Group>
                </Col>

                <br />

                <Col>
                  <Form.Group>
                    <Form.Label>Hora</Form.Label>
                    <Dropdown>
                      <Dropdown.Toggle variant="outline-info" disabled={!selectedDate || seleccionDesdeTabla}>{hora}</Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "240px", overflowY: "auto", }}>
                        {horasDisponibles.length === 0 ? (
                          <Dropdown.Item disabled>Sin horas</Dropdown.Item>
                        ) : (
                          horasDisponibles.map((h) => (
                            <Dropdown.Item key={h} onClick={() => seleccionarHora(h)}>
                              <h6 className="alineacion mb-0">{h}</h6>
                            </Dropdown.Item>
                          ))
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Form.Group>
                </Col>

                {seleccionDesdeTabla && (
                  <div className="mt-3">
                    <Button size="sm" variant="outline-secondary" onClick={resetSeleccion}>Limpiar selección</Button>
                  </div>
                )}
              </Form>

              {/* COLUMNA DERECHA — Tabla 14 días */}
              <div style={{ flex: 1, minWidth: "70%", maxWidth: "70%", maxHeight: "450px", overflowY: "auto" }}>
                <h5 className="mb-2">Próximos turnos disponibles</h5>
                {citasTabla.length === 0 ? (
                  <p className="text-muted">
                    No hay proximos turnos.
                  </p>
                ) : (
                  <Table striped hover size="sm">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Hora</th>
                        <th>Profesional</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {citasTabla.map((c, i) => {
                        const activa = seleccionDesdeTabla && c.profesional._id === doctor && c.fecha === fechaStr && c.hora === hora;
                        return (
                          <tr key={i} onClick={() => seleccionarDeTabla(c)} style={{ cursor: "pointer", backgroundColor: activa ? "#d1ecf1" : undefined, }}>
                            <td>{dayjs(c.fecha).format("DD/MM")}</td>
                            <td>{c.hora}</td>
                            <td>{c.profesional.nombre} {c.profesional.apellido} {c.especialidad.map((esp, i) => <span key={i}>. {esp}, </span>)}</td>
                            <td>
                              {activa && (
                                <span className="badge bg-info">Elegido</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
          <Button variant="info" onClick={saveDate} disabled={!seleccionCompleta}>Agendar turno</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Apointment;